import { mapActions, mapGetters } from 'vuex';
import getCompanyId from '@/composables/get-companyid';
import getLocationId from '@/composables/get-locationid';

export default {
	beforeRouteLeave(to, from, next) {
		this.removeConcurrentUser(from);
		next();
	},
	created() {
		this.setPageTitleAction(this.pageTitle);

		if (this.hubReady) {
			this.addConcurrentUser(this.$route);
		}
	},
	mounted() {
		//router events and component events not triggered when going to another page via a link
		// window.addEventListener('onbeforeunload ', this.onBeforeUnload);
		window.onbeforeunload = this.onBeforeUnload;
	},
	destroyed() {
		//router events and component events not triggers when going to another page via a link
		window.removeEventListener('onbeforeunload ', this.onBeforeUnload);
	},
	watch: {
		hubReady(newValue) {
			if (newValue) {
				this.addConcurrentUser(this.$route);
			}
		}
	},
	computed: {
		...mapGetters('principal', ['user']),
		...mapGetters('user', ['userInfo', 'userInfoSlim']),
		...mapGetters('hub', ['hubReady']),
		companyId() {
			return getCompanyId(this.$route);
		},
		locationId() {
			return getLocationId(this.$route);
		},
		pageTitle() {
			let title;

			if (this.$route && this.$route.meta && this.$route.meta.pageTitle) {
				title = this.$route.meta.pageTitle;
			}

			return title;
		}
	},
	methods: {
		...mapActions('user', ['setPageTitleAction']),
		...mapActions('app', ['setPageLoadingAction']),
		...mapActions('communicationHub', [
			'addConcurrentUserAction',
			'removeConcurrentUserAction'
		]),
		...mapActions('hub', ['onUserDisconnectAction']),
		showPageLoader() {
			this.setPageLoadingAction(true);
		},
		hidePageLoader() {
			this.setPageLoadingAction(false);
		},
		addConcurrentUser(route) {
			if (route.meta && route.meta.displayConcurrentUsers) {
				this.addConcurrentUserAction({
					groupName: route.path,
					user: this.userInfoSlim
				});
			}
		},
		removeConcurrentUser(route) {
			if (route.meta && route.meta.displayConcurrentUsers) {
				this.removeConcurrentUserAction({
					groupName: route.path,
					user: this.userInfoSlim
				});
			}
		},
		onBeforeUnload() {
			this.removeConcurrentUser(this.$route);

			if (this.hubReady) {
				this.onUserDisconnectAction(this.user);
			}
		}
	}
};
